import type { FormatStrings } from "@skilitics/localization";
import { traverseNodeSubtree } from "@skilitics/nautilus-core-designer-data";

import type { GetNodeMultilingualProperties } from "../../state/index.ts";
import type { DesignerNode, GetManifestByTypeId } from "../../types/index.ts";

export interface ResolveSubtreeMultilingualNodesCreateOptions {
  getManifest: GetManifestByTypeId;
  getNodeMultilingualProperties: GetNodeMultilingualProperties;
}

export const resolveSubtreeMultilingualNodesCreate =
  ({ getManifest, getNodeMultilingualProperties }: ResolveSubtreeMultilingualNodesCreateOptions) =>
  (startNode: DesignerNode) => {
    type Match = {
      node: DesignerNode;
      properties: {
        name: string;
        title: FormatStrings;
        on: boolean;
        canBeToggled?: boolean;
      }[];
    };

    const matches: Match[] = [];

    traverseNodeSubtree(startNode, (node) => {
      const {
        designer: { multilingual },
      } = getManifest(node.typeId);
      if (!multilingual) {
        return;
      }
      const onProperties = getNodeMultilingualProperties(node);
      const properties = (multilingual ? Object.entries(multilingual) : []).map(([name, { title, optIn }]) => ({
        name,
        title,
        on: onProperties.includes(name),
        canBeToggled: !!optIn,
        dependents: typeof optIn === "object" ? (optIn.dependents ?? []) : [],
      }));
      matches.push({ node, properties });
    });

    return matches;
  };

export type ResolveSubtreeMultilingualNodes = ReturnType<typeof resolveSubtreeMultilingualNodesCreate>;
